interface SaveChangesConfirmationProps {
  onClose: () => void;
  onConfirm: () => void;
}
export const SaveChangesConfirmation = ({
  onClose,
  onConfirm,
}: SaveChangesConfirmationProps) => {
  return (
    <div className="w-[480px] h-[180px] rounded gap-2 bg-white shadow-[0_1px_2px_0_#C5C9E2]">
      <div className="flex justify-between rounded-tr-lg rounded-tl-lg p-4">
        <div className="flex gap-2">
          <div className="p-1 gap-2">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 0C5.34375 0 0 5.39062 0 12C0 18.6562 5.34375 24 12 24C18.6094 24 24 18.6562 24 12C24 5.39062 18.6094 0 12 0ZM12 6C12.7969 6 13.5 6.70312 13.5 7.5C13.5 8.34375 12.7969 9 12 9C11.1562 9 10.5 8.34375 10.5 7.5C10.5 6.70312 11.1562 6 12 6ZM13.875 18H10.125C9.46875 18 9 17.5312 9 16.875C9 16.2656 9.46875 15.75 10.125 15.75H10.875V12.75H10.5C9.84375 12.75 9.375 12.2812 9.375 11.625C9.375 11.0156 9.84375 10.5 10.5 10.5H12C12.6094 10.5 13.125 11.0156 13.125 11.625V15.75H13.875C14.4844 15.75 15 16.2656 15 16.875C15 17.5312 14.4844 18 13.875 18Z"
                fill="#376BFC"
              />
            </svg>
          </div>
          <h2 className="font-semibold text-xl text-[#000A16]">Save Changes</h2>
        </div>
        <div className="h-6 w-6 p-2 gap-2.5 flex">
          <button className="cursor-pointer" onClick={onClose} type="button">
            <svg
              width="14"
              height="13"
              viewBox="0 0 14 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.6875 11.1484C13.0391 11.5391 13.0391 12.125 12.6875 12.4766C12.2969 12.8672 11.7109 12.8672 11.3594 12.4766L6.75 7.82812L2.10156 12.4766C1.71094 12.8672 1.125 12.8672 0.773438 12.4766C0.382812 12.125 0.382812 11.5391 0.773438 11.1484L5.42188 6.5L0.773438 1.85156C0.382812 1.46094 0.382812 0.875 0.773438 0.523438C1.125 0.132812 1.71094 0.132812 2.0625 0.523438L6.75 5.21094L11.3984 0.5625C11.75 0.171875 12.3359 0.171875 12.6875 0.5625C13.0781 0.914062 13.0781 1.5 12.6875 1.89062L8.03906 6.5L12.6875 11.1484Z"
                fill="#000A16"
                fillOpacity="0.7"
              />
            </svg>
          </button>
        </div>
      </div>
      <div className="flex flex-col gap-4 w-full">
        <div className="flex flex-col pr-4 pl-[52px] gap-6 w-full">
          <p className="font-normal text-base">
            Are you sure you want to save these changes?
          </p>
          <div className="flex gap-4 w-full">
            <button
              type="button"
              onClick={onConfirm}
              className="rounded py-1.5 px-6 gap-[5.69px] h-10 w-[198px] bg-[#004834]"
            >
              <span className="text-white text-lg font-semibold text-center">
                Save
              </span>
            </button>
            <button
              type="button"
              onClick={onClose}
              className="rounded p-2 gap-2.5 h-10 w-[198px]"
            >
              <span className="text-[#004834] text-base font-bold text-center">
                Cancel
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
